import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog, DialogContent } from "../../../components";
import {
  ColecoesService,
  notification,
  ProdutosService,
} from "../../../services";
import { responseErros } from "../../../utils";
import AddColecao from "../add-colecao/add-colecao.view";
import { PermisoesHelper } from "../../../helpers";

const ListColecoesView = () => {
  const [id, setId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [colecoes, setColecoes] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [produtosList, setProdutosList] = useState([]);
  const colunas = [
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 1000,
      filtrar: true,
    },
    {
      field: "ativado",
      headerName: "Status",
      flex: 500,
      valueGetter: (params) => (params.value ? "Ativado" : "Desativado"),
    },
  ];
  const colecoesService = new ColecoesService();
  const produtosService = new ProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("colecoes-visualizar");

  useEffect(() => {
    buscarColecoes();
  }, [openDialog]);

  useEffect(() => {
    buscarProdutos();
  }, []);

  const buscarColecoes = async function (filter) {
    setLoading(true);
    const result = await colecoesService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setColecoes(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarProdutos = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await produtosService.getAllProdutosSimples(filtros);
    if (!res.isAxiosError) {
      setProdutosList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleClickOpenDialog = (id) => {
    setId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onClickDeleteColecao = async function (id) {
    const produto = produtosList.some((item) => item.colecaoId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir essa coleção?`
    );
    if (retornoAlerta.isConfirmed) {
      if (produto) {
        notification.alertaGenericos(
          "Não se pode remover Coleção inserida em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await colecoesService.deletar(id);
      if (!result.isAxiosError) {
        buscarColecoes();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const sendServerDatagrid = (props) => {
    buscarColecoes(props.filtros);
  };

  return (
    <ListLayout
      title="Coleções"
      loading={loading}
      onClickCadastrar={handleClickOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("colecoes-cadastrar")}
    >
      <DataGrid
        rows={colecoes}
        columns={colunas}
        rowCount={rowCount}
        onClickEdit={handleClickOpenDialog}
        onClickDelete={onClickDeleteColecao}
        editShow={permissoesHelper.temPermisao("colecoes-editar")}
        deleteShow={permissoesHelper.temPermisao("colecoes-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        PaperComponent="div"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <AddColecao id={id} handleCloseDialog={handleCloseDialog} />
        </DialogContent>
      </Dialog>
    </ListLayout>
  );
};

export default ListColecoesView;
